'use client';
import { useState } from 'react';
import PlusIcon from '../icons/PlusIcon';
import MinusIcon from '../icons/MinusIcon';
import useCategoryStore from '@/store/category.store';
import { findObjectById } from '@/utils/global';
const CategoryDescription = ({ categoryName, categoryId }) => {
  const [show, setShow] = useState(true);

  const { categoryTreeData } = useCategoryStore((state) => state);
  const currentCategory = findObjectById(
    categoryTreeData?.children_data || [],
    'innova_url',
    categoryId
  );

  if (!currentCategory?.category_text_description) return;

  const description = currentCategory?.category_text_description;
  return (
    <div className='mx-auto mb-5 flex items-center justify-between gap-4 rounded-[10px] border border-gray-200 px-4 py-3 ease-linear *:transition-all *:duration-500 *:ease-linear'>
      <div>
        <p className='text-lg font-bold'>{categoryName}</p>
        {show && <p className='text-tertiary-600 mt-2'>{description}</p>}
      </div>

      {show ? (
        <MinusIcon
          className='size-6 cursor-pointer'
          onClick={() => setShow(false)}
        />
      ) : (
        <PlusIcon
          className='size-4 cursor-pointer'
          onClick={() => setShow(true)}
        />
      )}
    </div>
  );
};

export default CategoryDescription;
